export default __webpack_public_path__ + "static/media/3.7d409f7f.png";